module.exports = __webpack_public_path__ + "static/media/register_bg_2.2fee0b50.png";